(function () {
  'use strict';

  if (window.KnickerSizeGuide) return;
  window.KnickerSizeGuide = true;

  var opener = null;
  var previousOverflow = '';

  document.addEventListener('click', function (event) {
    var dialog = document.getElementById('SizeGuide');
    if (!dialog) return;

    var trigger = event.target.closest('[data-size-guide-trigger]');
    if (trigger) {
      event.preventDefault();
      if (dialog.open) return;
      opener = trigger;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      return;
    }

    if (event.target.closest('[data-size-guide-close]') && dialog.open) {
      dialog.close();
      return;
    }

    if (event.target === dialog && dialog.open) {
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) {
        dialog.close();
      }
    }
  });

  // Native dialog handles Escape, focus containment and an inert background.
  document.addEventListener('close', function (event) {
    if (event.target.id !== 'SizeGuide') return;
    document.documentElement.style.overflow = previousOverflow;
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }, true);
})();
